var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _g, _path137, _path138, _path139, _path140, _path141, _g2, _path142, _path143, _path144, _g3, _path145, _path146, _path147, _g4, _path148, _path149, _path150, _g5, _path151, _path152, _path153, _g6, _path154, _path155, _path156, _g7, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulbicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 580,
    viewBox: "0 0 319 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M525.48 439.837C491.643 492.757 419.862 529.285 294.443 529.285C177.84 529.285 107.103 497.71 69.8789 450.741C-38.2795 314.36 136.242 48.0938 290.627 48.0938C440.998 48.0938 614.441 300.672 525.48 439.837Z",
    fill: "#FF8D5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M525.48 439.837C491.643 492.757 419.862 529.285 294.443 529.285C177.84 529.285 107.103 497.71 69.8789 450.741C-38.2795 314.36 136.242 48.0938 290.627 48.0938C440.998 48.0938 614.441 300.672 525.48 439.837Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M525.481 438.991V439.838C491.643 492.757 419.863 529.285 294.443 529.285C177.84 529.285 107.103 497.71 69.8789 450.742V431.022H83.3349V443.874H91.2809V458.56H107.277V431.033H117.427V409.306H134.978V379.634L137.959 376.664V409.318H144.015V444.501H151.079V484.88H160.429V456.124L175.509 441.044V412.38L179.708 416.568V457.342L184.731 462.376V476.296H202.421V460.404H196.041V456.124H202.432V449.999H219.171V430.778H223.463V449.999H230.841V491.608H250.804V476.32L262.404 464.72H271.789V443.271H277.241V464.685H283.945L295.627 476.378V491.608H310.997V463.467H325.148L341.389 447.227V424.839H345.971V448.746L360.621 463.397H380.446V479.95H392.452V445.104H407.683V403.68H404.852V387.661H407.683V376.664H412.172V413.935L418.61 420.361V446.334H434.212V453.062H451.612V423.4H459.558V393.24H462.191V423.4H473.141L486.041 436.45V447.552H496.968V429.815H514.693V438.991H525.481Z",
    fill: "#FF8D5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 413.039H121.939V420.266H129.166V413.039Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.273 413.039H131.046V420.266H138.273V413.039Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 422.277H121.939V429.504H129.166V422.277Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.273 422.277H131.046V429.504H138.273V422.277Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 431.496H121.939V438.723H129.166V431.496Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.273 431.496H131.046V438.723H138.273V431.496Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 440.73H121.939V447.957H129.166V440.73Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.273 440.73H131.046V447.957H138.273V440.73Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 449.965H121.939V457.192H129.166V449.965Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.273 449.965H131.046V457.192H138.273V449.965Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 459.195H121.939V466.422H129.166V459.195Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 468.43H121.939V475.656H129.166V468.43Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M138.273 468.43H131.046V475.656H138.273V468.43Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 477.664H121.939V484.891H129.166V477.664Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M138.273 477.664H131.046V484.891H138.273V477.664Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 486.898H121.939V494.125H129.166V486.898Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M138.273 486.898H131.046V494.125H138.273V486.898Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.367 449.965H140.141V457.192H147.367V449.965Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M147.367 459.195H140.141V466.422H147.367V459.195Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M147.367 468.43H140.141V475.656H147.367V468.43Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M147.367 486.898H140.141V494.125H147.367V486.898Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120.061 440.73H112.834V447.957H120.061V440.73Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.061 449.965H112.834V457.192H120.061V449.965Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M120.061 459.195H112.834V466.422H120.061V459.195Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M120.061 468.43H112.834V475.656H120.061V468.43Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M177.249 447.738H171.461V454.965H177.249V447.738Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M177.249 456.867H171.461V464.094H177.249V456.867Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M177.249 465.984H171.461V473.211H177.249V465.984Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M177.249 475.102H171.461V482.328H177.249V475.102Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M177.249 484.219H171.461V491.446H177.249V484.219Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M177.249 493.336H171.461V500.563H177.249V493.336Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M169.662 456.914H163.874V464.141H169.662V456.914Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M169.662 466.031H163.874V473.258H169.662V466.031Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M169.662 475.137H163.874V482.363H169.662V475.137Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M169.662 484.254H163.874V491.481H169.662V484.254Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M169.662 493.363H163.874V500.59H169.662V493.363Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M169.662 502.48H163.874V509.707H169.662V502.48Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0003 448.746H81.2119V455.973H87.0003V448.746Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0003 457.98H81.2119V465.207H87.0003V457.98Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0003 467.211H81.2119V474.438H87.0003V467.211Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0003 485.668H81.2119V492.895H87.0003V485.668Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0003 494.902H81.2119V502.129H87.0003V494.902Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4144 448.746H73.626V455.973H79.4144V448.746Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4144 457.98H73.626V465.207H79.4144V457.98Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4144 467.211H73.626V474.438H79.4144V467.211Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4144 476.438H73.626V483.664H79.4144V476.438Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4144 485.668H73.626V492.895H79.4144V485.668Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M219.646 453.492H213.336V460.719H219.646V453.492Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M227.592 453.492H221.281V460.719H227.592V453.492Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M219.646 462.594H213.336V469.821H219.646V462.594Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M227.592 462.594H221.281V469.821H227.592V462.594Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M219.646 471.703H213.336V478.93H219.646V471.703Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M227.592 471.703H221.281V478.93H227.592V471.703Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M219.646 480.809H213.336V488.035H219.646V480.809Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M227.592 480.809H221.281V488.035H227.592V480.809Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M219.646 489.914H213.336V497.141H219.646V489.914Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M227.592 489.914H221.281V497.141H227.592V489.914Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M219.646 499.02H213.336V506.246H219.646V499.02Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M227.592 499.02H221.281V506.246H227.592V499.02Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M211.712 453.492H205.401V460.719H211.712V453.492Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M211.712 462.594H205.401V469.821H211.712V462.594Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M211.712 471.703H205.401V478.93H211.712V471.703Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M211.712 480.809H205.401V488.035H211.712V480.809Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M272.623 476.41H265.396V483.637H272.623V476.41Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M281.73 476.41H274.503V483.637H281.73V476.41Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M272.623 485.473H265.396V492.699H272.623V485.473Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M281.73 485.473H274.503V492.699H281.73V485.473Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M272.623 494.531H265.396V501.758H272.623V494.531Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M281.73 494.531H274.503V501.758H281.73V494.531Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M272.623 503.578H265.396V510.805H272.623V503.578Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M281.73 503.578H274.503V510.805H281.73V503.578Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M272.623 512.637H265.396V519.864H272.623V512.637Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M281.73 512.637H274.503V519.864H281.73V512.637Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M290.824 476.41H283.598V483.637H290.824V476.41Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M290.824 485.473H283.598V492.699H290.824V485.473Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M290.824 503.578H283.598V510.805H290.824V503.578Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M290.824 512.637H283.598V519.864H290.824V512.637Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M263.53 476.41H256.303V483.637H263.53V476.41Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M263.53 485.473H256.303V492.699H263.53V485.473Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M263.53 494.531H256.303V501.758H263.53V494.531Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M322.921 477.598H315.694V484.824H322.921V477.598Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M322.921 486.805H315.694V494.031H322.921V486.805Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M322.921 514.449H315.694V521.676H322.921V514.449Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M322.921 523.656H315.694V530.883H322.921V523.656Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M322.921 468.387H315.694V475.614H322.921V468.387Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M272.623 521.688H265.396V528.914H272.623V521.688Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M281.73 521.688H274.503V528.914H281.73V521.688Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M272.623 530.746H265.396V537.973H272.623V530.746Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M263.53 521.688H256.303V528.914H263.53V521.688Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M219.646 508.125H213.336V515.352H219.646V508.125Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M227.592 508.125H221.281V515.352H227.592V508.125Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M227.592 517.234H221.281V524.461H227.592V517.234Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M211.712 508.125H205.401V515.352H211.712V508.125Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M211.712 526.34H205.401V533.567H211.712V526.34Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M177.249 520.691H171.461V527.918H177.249V520.691Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M177.249 529.82H171.461V537.047H177.249V529.82Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M169.662 511.594H163.874V518.821H169.662V511.594Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M169.662 520.703H163.874V527.93H169.662V520.703Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M138.273 496.227H131.046V503.453H138.273V496.227Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M129.166 505.461H121.939V512.688H129.166V505.461Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M294.454 97.5343C294.454 96.1075 294.454 94.6807 294.396 93.2539",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M294.396 140.196C294.527 131.434 294.581 122.672 294.558 113.91",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M294.396 163.49V156.066",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M319.511 163.495L331.9 119.473",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M248.367 128.008C252.59 141.185 256.174 154.607 260.443 167.575",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M240.282 101.5C242.177 107.687 244.064 113.873 245.943 120.06",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M250.212 166.973L251.952 170.835",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M238.159 140.199L246.952 159.722",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M188.662 187.332C193.14 192.506 197.583 197.714 201.909 203.027",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M168.664 163.68C173.304 169.561 178.257 175.28 183.176 180.987",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M159.453 152.793L162.933 156.957",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M170.949 186.516L194.648 209.391",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M173.466 261.664L180.681 263.508",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M121.857 248.473L166.158 259.841",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M108.691 245.109L113.482 246.339",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M163.827 246.688L180.682 254.309",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M144.687 238.047L156.287 243.29",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M175.299 415.34L172.724 418.889",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M191.191 393.574C187.548 398.69 183.86 403.782 180.066 408.793",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M213.439 363C207.419 370.737 201.735 378.741 196.039 386.745",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M192.653 369.23L179.44 381.109",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M206.317 356.945L198.51 363.963",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M138.48 341.309L123.203 348.93",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M184.44 318.422C172.167 324.489 158.757 330.741 145.812 337.678",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M180.681 299.852L147.25 305.686",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M211.979 165.879L224.008 184.984",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6 290L107.288 290.336",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M167.179 289.41C156.449 289.631 145.719 289.677 134.978 289.816",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M179.44 289.086L175.102 289.225",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M160.08 206.621L143.388 195.914",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M189.23 225.31L167.341 211.285",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M290.499 180.449C236.107 181.215 191.899 225.817 191.505 280.209C191.389 295.328 194.695 310.278 201.175 323.938C207.656 337.598 217.143 349.615 228.927 359.089C233.038 362.458 236.084 366.947 237.696 372.012L242.336 386.361H341.493L346.237 371.722C347.818 366.805 350.792 362.453 354.798 359.194C371.106 346.097 382.918 328.235 388.585 308.101C394.252 287.967 393.49 266.567 386.407 246.887C379.323 227.206 366.272 210.229 349.074 198.325C331.876 186.421 311.39 180.183 290.476 180.484L290.499 180.449Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1293_18535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 191,
    y: 180,
    width: 202,
    height: 207
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M290.499 180.445C236.107 181.211 191.899 225.813 191.505 280.205C191.389 295.324 194.695 310.274 201.175 323.934C207.656 337.594 217.143 349.612 228.927 359.085C233.038 362.454 236.084 366.943 237.696 372.008L242.336 386.357H341.493L346.237 371.718C347.818 366.801 350.792 362.449 354.798 359.19C371.106 346.093 382.918 328.231 388.585 308.097C394.252 287.964 393.49 266.563 386.407 246.883C379.323 227.202 366.272 210.225 349.074 198.321C331.876 186.417 311.39 180.179 290.476 180.48L290.499 180.445Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1293_18535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.497 378.055C267.555 380.572 267.497 381.999 267.497 381.999",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.06 347.32C266.301 356.438 266.927 364.778 267.24 370.996",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.117 296.34H249.064C256.361 307.395 260.769 322.625 263.437 337.195",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.153 293.453L269.33 296.342H258.495",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.902 301.651L276.962 304.83L271.545 288.555L270.687 291.559",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.096 297.811L286.95 304.83L281.742 288.555L278.946 298.09",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.303 295.967L302.134 288.555L296.925 304.83L291.937 288.555L290.476 293.322",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.747 296.338H314.534L312.33 288.555L306.901 304.83L305.196 298.995",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 345.814C319.557 341.905 320.241 337.857 321.053 333.797",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.994 364.954C317.284 360.871 317.702 356.266 318.293 351.348",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.507 373.71C316.507 372.643 316.611 371.483 316.669 370.23",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.332 381.998C316.332 381.998 316.332 380.095 316.402 376.812",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.499 180.445C236.107 181.211 191.899 225.813 191.505 280.205C191.389 295.324 194.695 310.274 201.175 323.934C207.656 337.594 217.143 349.612 228.927 359.085C233.038 362.454 236.084 366.943 237.696 372.008L242.336 386.357H341.493L346.237 371.718C347.818 366.801 350.792 362.449 354.798 359.19C371.106 346.093 382.918 328.231 388.585 308.097C394.252 287.964 393.49 266.563 386.407 246.883C379.323 227.202 366.272 210.225 349.074 198.321C331.876 186.417 311.39 180.179 290.476 180.48L290.499 180.445ZM291.938 344.817C276.73 344.82 261.863 340.312 249.217 331.864C236.572 323.416 226.715 311.408 220.895 297.358C215.075 283.308 213.552 267.847 216.519 252.932C219.486 238.016 226.81 224.315 237.564 213.563C248.319 202.81 262.021 195.488 276.937 192.523C291.853 189.558 307.313 191.083 321.362 196.906C335.411 202.728 347.418 212.586 355.864 225.233C364.31 237.88 368.816 252.748 368.811 267.956C368.808 288.342 360.707 307.892 346.291 322.306C331.875 336.72 312.324 344.817 291.938 344.817Z",
    fill: "#FF8D5E"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M290.499 180.449C236.107 181.215 191.899 225.817 191.505 280.209C191.389 295.328 194.695 310.278 201.175 323.938C207.656 337.598 217.143 349.615 228.927 359.089C233.038 362.458 236.084 366.947 237.696 372.012L242.336 386.361H341.493L346.237 371.722C347.818 366.805 350.792 362.453 354.798 359.194C371.106 346.097 382.918 328.235 388.585 308.101C394.252 287.967 393.49 266.567 386.407 246.887C379.323 227.206 366.272 210.229 349.074 198.325C331.876 186.421 311.39 180.183 290.476 180.484L290.499 180.449Z",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M303.55 482.872H280.35C279.774 482.873 279.209 482.721 278.712 482.431C278.214 482.142 277.803 481.725 277.519 481.225L274.039 475.1L260.618 467.316H323.409L309.999 475.1L306.519 481.225C306.222 481.744 305.787 482.172 305.264 482.462C304.741 482.753 304.148 482.894 303.55 482.872Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M329.51 462.699H254.365C255.696 465.475 257.784 467.819 260.388 469.461C262.992 471.103 266.007 471.976 269.086 471.979H314.778C317.858 471.975 320.874 471.102 323.48 469.461C326.086 467.819 328.176 465.475 329.51 462.699Z",
    fill: "#757575",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M329.51 462.7H254.365L245.422 399.016H338.454L329.51 462.7Z",
    fill: "#999999"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1293_18535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 245,
    y: 399,
    width: 94,
    height: 64
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M329.509 462.704H254.364L245.421 399.02H338.453L329.509 462.704Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1293_18535)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M258.217 441.757L259.04 449.054L325.404 443.915L326.251 436.352L258.217 441.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M283.214 460.526H317.84C318.956 460.524 320.051 460.228 321.016 459.668C321.982 459.108 322.782 458.303 323.338 457.336L283.214 460.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M259.388 452.15L259.689 454.876C259.883 456.525 260.716 458.033 262.009 459.075L324.267 454.249L325.09 446.93L259.388 452.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M327.758 422.977L328.013 420.68H291.346H289.838H255.861L256.731 428.486L327.758 422.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M257.079 431.584L257.88 438.648L326.598 433.324L327.41 426.004L257.079 431.584Z",
    fill: "white"
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M329.51 462.7H254.365L245.422 399.016H338.454L329.51 462.7Z",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M249.03 430.602C248.319 430.628 247.627 430.371 247.106 429.887C246.585 429.403 246.278 428.732 246.252 428.021C246.226 427.311 246.483 426.619 246.967 426.098C247.451 425.577 248.122 425.269 248.833 425.243L334.673 418.898C335.382 418.846 336.083 419.077 336.621 419.542C337.16 420.006 337.491 420.665 337.544 421.375C337.596 422.084 337.365 422.784 336.9 423.323C336.436 423.861 335.776 424.193 335.067 424.246L249.227 430.591L249.03 430.602Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1293_18535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 246,
    y: 418,
    width: 92,
    height: 13
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M249.029 430.606C248.318 430.632 247.626 430.375 247.105 429.891C246.584 429.407 246.277 428.736 246.251 428.025C246.225 427.315 246.482 426.623 246.966 426.102C247.45 425.581 248.121 425.273 248.832 425.247L334.672 418.902C335.381 418.849 336.082 419.081 336.62 419.545C337.159 420.01 337.491 420.669 337.543 421.378C337.595 422.088 337.364 422.788 336.899 423.327C336.435 423.865 335.775 424.197 335.066 424.249L249.226 430.595L249.029 430.606Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1293_18535)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.202 420.339C336.995 420.744 336.686 421.089 336.306 421.339C335.926 421.589 335.487 421.736 335.033 421.766L249.193 428.111H248.996C248.76 428.246 248.495 428.318 248.224 428.321C247.953 428.325 247.686 428.259 247.447 428.131C247.208 428.003 247.006 427.817 246.859 427.589C246.712 427.361 246.625 427.1 246.606 426.83C246.588 426.56 246.638 426.289 246.753 426.044C246.867 425.798 247.042 425.586 247.261 425.426C247.48 425.267 247.736 425.166 248.005 425.132C248.274 425.099 248.547 425.134 248.799 425.235L334.639 418.889C335.161 418.853 335.683 418.971 336.139 419.229C336.595 419.486 336.964 419.873 337.202 420.339Z",
    fill: "white"
  })))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M249.03 430.602C248.319 430.628 247.627 430.371 247.106 429.887C246.585 429.403 246.278 428.732 246.252 428.021C246.226 427.311 246.483 426.619 246.967 426.098C247.451 425.577 248.122 425.269 248.833 425.243L334.673 418.898C335.382 418.846 336.083 419.077 336.621 419.542C337.16 420.006 337.491 420.665 337.544 421.375C337.596 422.084 337.365 422.784 336.9 423.323C336.436 423.861 335.776 424.193 335.067 424.246L249.227 430.591L249.03 430.602Z",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M250.56 440.948C249.85 440.974 249.158 440.717 248.637 440.233C248.116 439.749 247.808 439.078 247.782 438.367C247.756 437.657 248.013 436.965 248.497 436.444C248.981 435.923 249.652 435.615 250.363 435.589L333.233 429.453C333.943 429.4 334.644 429.632 335.182 430.096C335.72 430.561 336.052 431.22 336.104 431.929C336.157 432.638 335.925 433.339 335.461 433.878C334.996 434.416 334.337 434.748 333.628 434.8L250.757 440.937L250.56 440.948Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1293_18535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 247,
    y: 429,
    width: 90,
    height: 12
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M250.559 440.944C249.849 440.97 249.157 440.713 248.636 440.229C248.115 439.745 247.807 439.074 247.781 438.363C247.755 437.653 248.012 436.961 248.496 436.44C248.98 435.919 249.651 435.611 250.362 435.585L333.233 429.449C333.942 429.396 334.643 429.628 335.181 430.092C335.719 430.557 336.051 431.216 336.104 431.925C336.156 432.634 335.924 433.335 335.46 433.874C334.995 434.412 334.336 434.744 333.627 434.796L250.757 440.933L250.559 440.944Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1293_18535)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.738 430.894C335.531 431.299 335.222 431.644 334.842 431.894C334.461 432.144 334.023 432.291 333.569 432.321L250.699 438.481H250.559C250.324 438.615 250.058 438.687 249.787 438.691C249.517 438.694 249.249 438.629 249.01 438.501C248.772 438.373 248.569 438.186 248.422 437.959C248.275 437.731 248.188 437.47 248.17 437.199C248.151 436.929 248.202 436.658 248.316 436.413C248.431 436.167 248.606 435.955 248.825 435.796C249.044 435.636 249.3 435.535 249.569 435.501C249.838 435.468 250.111 435.503 250.362 435.604L333.233 429.468C333.742 429.445 334.248 429.566 334.692 429.819C335.135 430.071 335.498 430.444 335.738 430.894Z",
    fill: "white"
  })))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M250.56 440.948C249.85 440.974 249.158 440.717 248.637 440.233C248.116 439.749 247.808 439.078 247.782 438.367C247.756 437.657 248.013 436.965 248.497 436.444C248.981 435.923 249.652 435.615 250.363 435.589L333.233 429.453C333.943 429.4 334.644 429.632 335.182 430.096C335.72 430.561 336.052 431.22 336.104 431.929C336.157 432.638 335.925 433.339 335.461 433.878C334.996 434.416 334.337 434.748 333.628 434.8L250.757 440.937L250.56 440.948Z",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M251.964 451.294C251.254 451.319 250.562 451.06 250.042 450.575C249.523 450.09 249.217 449.418 249.192 448.708C249.167 447.997 249.426 447.305 249.911 446.786C250.396 446.266 251.068 445.96 251.779 445.935L331.703 440.031C332.054 440.005 332.407 440.048 332.741 440.159C333.075 440.269 333.385 440.444 333.651 440.674C333.918 440.904 334.137 441.185 334.295 441.499C334.453 441.814 334.548 442.156 334.574 442.507C334.6 442.858 334.556 443.211 334.446 443.546C334.335 443.88 334.16 444.189 333.93 444.456C333.7 444.722 333.42 444.941 333.105 445.099C332.791 445.258 332.448 445.352 332.097 445.378L252.173 451.294H251.964Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1293_18535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 249,
    y: 440,
    width: 86,
    height: 12
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M251.964 451.298C251.254 451.323 250.562 451.064 250.042 450.579C249.523 450.094 249.217 449.422 249.192 448.711C249.167 448.001 249.426 447.309 249.911 446.789C250.396 446.27 251.068 445.964 251.779 445.939L331.703 440.035C332.054 440.009 332.407 440.052 332.741 440.163C333.075 440.273 333.385 440.448 333.651 440.678C333.918 440.908 334.137 441.189 334.295 441.503C334.453 441.818 334.548 442.16 334.574 442.511C334.6 442.862 334.556 443.215 334.446 443.549C334.335 443.884 334.16 444.193 333.93 444.46C333.7 444.726 333.42 444.945 333.105 445.103C332.791 445.261 332.448 445.356 332.097 445.382L252.173 451.298H251.964Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1293_18535)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.266 441.472C334.062 441.88 333.753 442.226 333.373 442.476C332.992 442.727 332.552 442.873 332.097 442.899L252.173 448.815H251.964C251.729 448.947 251.464 449.017 251.194 449.018C250.924 449.02 250.658 448.954 250.421 448.825C250.184 448.696 249.983 448.51 249.837 448.283C249.691 448.056 249.605 447.796 249.587 447.527C249.568 447.257 249.618 446.988 249.732 446.743C249.846 446.499 250.019 446.287 250.237 446.127C250.454 445.967 250.709 445.865 250.976 445.83C251.244 445.795 251.516 445.829 251.767 445.927L331.691 440.022C332.215 439.985 332.739 440.103 333.197 440.36C333.655 440.618 334.026 441.005 334.266 441.472Z",
    fill: "white"
  })))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M251.964 451.294C251.254 451.319 250.562 451.06 250.042 450.575C249.523 450.09 249.217 449.418 249.192 448.708C249.167 447.997 249.426 447.305 249.911 446.786C250.396 446.266 251.068 445.96 251.779 445.935L331.703 440.031C332.054 440.005 332.407 440.048 332.741 440.159C333.075 440.269 333.385 440.444 333.651 440.674C333.918 440.904 334.137 441.185 334.295 441.499C334.453 441.814 334.548 442.156 334.574 442.507C334.6 442.858 334.556 443.211 334.446 443.546C334.335 443.88 334.16 444.189 333.93 444.456C333.7 444.722 333.42 444.941 333.105 445.099C332.791 445.258 332.448 445.352 332.097 445.378L252.173 451.294H251.964Z",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M253.437 461.675C252.727 461.701 252.035 461.444 251.514 460.96C250.993 460.476 250.685 459.805 250.659 459.094C250.633 458.384 250.89 457.692 251.374 457.171C251.858 456.65 252.529 456.342 253.24 456.316L330.229 450.621C330.938 450.568 331.639 450.8 332.178 451.264C332.716 451.729 333.048 452.388 333.1 453.097C333.153 453.806 332.921 454.507 332.457 455.046C331.992 455.584 331.333 455.916 330.624 455.968L253.634 461.675H253.437Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1293_18535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 250,
    y: 450,
    width: 84,
    height: 12
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M253.438 461.679C252.728 461.705 252.036 461.448 251.515 460.964C250.994 460.48 250.686 459.809 250.66 459.098C250.634 458.388 250.891 457.696 251.375 457.175C251.859 456.654 252.53 456.346 253.241 456.32L330.23 450.624C330.939 450.572 331.64 450.804 332.179 451.268C332.717 451.733 333.049 452.392 333.101 453.101C333.154 453.81 332.922 454.511 332.458 455.049C331.993 455.588 331.334 455.92 330.625 455.972L253.635 461.679H253.438Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1293_18535)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.805 452.027C332.597 452.433 332.288 452.778 331.908 453.03C331.528 453.282 331.09 453.432 330.635 453.466L253.635 459.161H253.437C253.202 459.295 252.936 459.367 252.665 459.371C252.394 459.374 252.127 459.309 251.888 459.181C251.649 459.053 251.447 458.866 251.3 458.639C251.153 458.411 251.066 458.15 251.048 457.88C251.029 457.609 251.08 457.339 251.194 457.093C251.309 456.848 251.484 456.635 251.703 456.476C251.922 456.317 252.178 456.215 252.447 456.182C252.716 456.148 252.989 456.184 253.24 456.284L330.229 450.589C330.752 450.552 331.274 450.668 331.732 450.924C332.189 451.179 332.562 451.563 332.805 452.027Z",
    fill: "white"
  })))), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M253.437 461.675C252.727 461.701 252.035 461.444 251.514 460.96C250.993 460.476 250.685 459.805 250.659 459.094C250.633 458.384 250.89 457.692 251.374 457.171C251.858 456.65 252.529 456.342 253.24 456.316L330.229 450.621C330.938 450.568 331.639 450.8 332.178 451.264C332.716 451.729 333.048 452.388 333.1 453.097C333.153 453.806 332.921 454.507 332.457 455.046C331.992 455.584 331.333 455.916 330.624 455.968L253.634 461.675H253.437Z",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M348.825 378.923L345.878 411.798L338.988 416.994H244.889L237.987 411.798L235.052 378.923L237.093 373.715H346.771L348.825 378.923Z",
    fill: "#FF8D5E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1293_18535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 235,
    y: 373,
    width: 114,
    height: 44
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M348.825 378.923L345.878 411.798L338.988 416.994H244.889L237.987 411.798L235.052 378.923L237.093 373.715H346.771L348.825 378.923Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1293_18535)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M345.879 411.797L338.989 416.994H244.889L237.987 411.797H345.879Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M348.825 378.923H235.052L237.093 373.715H346.771L348.825 378.923Z",
    fill: "white"
  }))), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M348.825 378.923L345.878 411.798L338.988 416.994H244.889L237.987 411.798L235.052 378.923L237.093 373.715H346.771L348.825 378.923Z",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M235.052 378.926H277.183",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M283.795 378.926H294.397",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M301.949 378.926H304.304",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M345.877 411.801H304.303",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M297.471 411.801H283.795",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M273.181 411.801H270.351",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M237.985 411.801H249.284",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M267.763 464.238C271.672 467.834 281.021 470.375 291.937 470.375C302.853 470.375 312.191 467.834 316.112 464.238H267.763Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M296.961 481.401H286.869C286.519 481.397 286.179 481.283 285.898 481.075C285.616 480.866 285.408 480.574 285.303 480.241L283.888 475.891H299.977L298.562 480.241C298.456 480.581 298.243 480.878 297.955 481.087C297.666 481.297 297.317 481.407 296.961 481.401Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M283.887 474.205H299.976L301.774 472.836H282.101L283.887 474.205Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbicon);
export default __webpack_public_path__ + "static/media/lightbulbicon.532a9dc927227d4cbce06e6eb03c37fd.svg";
export { ForwardRef as ReactComponent };